/** Role-based nav and route access — owner keeps full app access. */

const NAV_BY_ROLE = {
    owner: [
        "dashboard", "calendar", "customers", "services", "staff",
        "pos", "memberships", "reports", "billing", "settings",
    ],
    manager: [
        "dashboard", "calendar", "customers", "services", "staff",
        "pos", "memberships", "reports",
    ],
    receptionist: ["calendar", "customers", "pos", "memberships"],
    stylist: ["calendar"],
    therapist: ["calendar"],
};

export function canAccess(role, section) {
    if (!role || role === "owner") return true;
    return (NAV_BY_ROLE[role] || []).includes(section);
}

export function defaultHome(role) {
    if (role === "receptionist" || role === "stylist" || role === "therapist") return "calendar";
    return "dashboard";
}

export const ALL_NAV = [
    { to: "dashboard", perm: "dashboard" },
    { to: "calendar", perm: "calendar" },
    { to: "customers", perm: "customers" },
    { to: "services", perm: "services" },
    { to: "staff", perm: "staff" },
    { to: "pos", perm: "pos" },
    { to: "memberships", perm: "memberships" },
    { to: "reports", perm: "reports" },
    { to: "billing", perm: "billing" },
    { to: "settings", perm: "settings" },
];

export function filteredNav(role) {
    return ALL_NAV.filter(({ perm }) => canAccess(role, perm));
}

export const ROLE_LABELS = {
    owner: "Owner",
    manager: "Manager",
    receptionist: "Receptionist",
    stylist: "Stylist",
    therapist: "Therapist",
};
